import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Stack, Typography } from '@mui/material';

export default function GoogleOAuthComplete() {
  const [params] = useSearchParams();
  const status = params.get('status');
  const email = params.get('email');
  const error = params.get('error');

  useEffect(() => {
    const message =
      status === 'success'
        ? { type: 'google-oauth-success', email }
        : { type: 'google-oauth-error', error: error || 'OAuth fehlgeschlagen' };

    if (window.opener) {
      window.opener.postMessage(message, window.location.origin);
      window.close();
    }
  }, [status, email, error]);

  return (
    <Stack alignItems="center" justifyContent="center" sx={{ minHeight: '100vh' }}>
      <Typography variant="meta">
        {status === 'success'
          ? 'Google Kalender verbunden. Du kannst dieses Fenster schliessen.'
          : `Fehler: ${error || 'OAuth fehlgeschlagen'}`}
      </Typography>
    </Stack>
  );
}
